import React from "react";
import CardEditor from "./components/CardEditor";

const App: React.FC = () => {
  return (
    <div
      className="min-h-screen "
      style={{
        backgroundImage: "url('/bg.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="relative z-1 w-full h-full">
        <div className="absolute left-8 top-8">
          <img
            src="/favicon.png"
            alt="Logo"
            className="w-32 h-32 object-contain"
          />
          <div className="text-white text-base font-medium tracking-wide mt-2">
            卡片笔记制作工具
          </div>
        </div>
        <CardEditor />
      </div>
    </div>
  );
};

export default App;
